/* eslint-disable */
var searchID = document.getElementById('gsearch');

if (searchID != null) {
    $(document).ready(function () {
        function getUrlParameter(name) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            return urlParams.get(name);
        }
        // Get the search term parameter from the URL
        let radioId = getUrlParameter('radioid');
        let checkId = getUrlParameter('checkid');
        let dropdownSelector = '';
        let selectedCollection = '';
        let actionUrl = '';
        var radioSelect;

        if (checkId)
            checkId =
                getUrlParameter('checkid').split('?').length == 2
                    ? getUrlParameter('checkid').split('?')[0]
                    : getUrlParameter('checkid');

        if (
            radioId == 'online-collections' ||
            radioId == 'bureau-of-military-history-1913-1921' ||
            radioId == 'military-service-pensions-collection'
        ) {
            var radioButton = document.getElementById('onlineCollectionsRadio');
            dropdownSelector = 'selectedCollection';
            selectedCollection = 'collectionChoice[]';
            actionUrl = 'onlinecollectionssearch';
        } else if (
            radioId == 'resources'
        ) {
            var radioButton = document.getElementById(
                'resourcesCollectionsRadio'
            );
            dropdownSelector = 'selectedResourceCollection';
            selectedCollection = 'resourcescollectionChoice[]';
            actionUrl = 'resourcesearch';

        } else if (
            radioId == 'reading-room-collections' ||
            radioId == 'department-of-defence-file-series'
        ) {
            var radioButton = document.getElementById(
                'readingCollectionsRadio'
            );
            dropdownSelector = 'selectedReadingRoomCollection';
            selectedCollection = 'collectionReadingRoomChoice[]';
            actionUrl = 'readingroomsearch';
        }
        if (radioButton) {
            radioButton.checked = true;
        }

        // use this to target the dropdown
        if (radioButton) {
            if (radioButton.id == 'onlineCollectionsRadio') {
                var dropdown = document.getElementById(dropdownSelector);

            } else if (radioButton.id == 'readingCollectionsRadio') {
                var dropdown = document.getElementById(dropdownSelector);

            } else if (radioButton.id == 'resourcesCollectionsRadio') {
                var dropdown = document.getElementById(dropdownSelector);

            }
        }

        switch (checkId) {
            // commented out collections path segments to be decided
            // case '':
            // radioSelect = 'oralhistories-people';
            // break;
            // case '':
            // radioSelect = 'oralhistories-stories';
            // break;
            case 'oral-histories-project-20th-century':
                radioSelect = 'oralhistories';
                break;
            case 'the-collins-papers-1917-1922':
                radioSelect = 'collins';
                break;
            case 'an-toglach-magazine-1918-1933':
                radioSelect = 'antoglac';
                break;
            case 'the-irish-volunteer-1914-1916':
                radioSelect = 'irishvol';
                break;
            case 'irish-army-census-collection-12-november-1922-13-november-1922':
                radioSelect = 'census';
                break;
            case 'military-archives-image-gallery-20th-century':
                radioSelect = 'gallery';
                break;
            case 'contemporary-documents-index':
                radioSelect = 'bmhcdindex';
                break;
            case 'maps-plans-drawings-collection-1702-2007':
                radioSelect = 'mpdsearch';
                break;
            case 'maps-plans-and-drawings':
                radioSelect = 'mpdsearch';
                break;
            case 'the-irish-sword':
                radioSelect = 'irish-sword';
                break;
            case 'bureau-of-military-history-image-gallery':
                radioSelect = 'bmhgallery';
                break;
            case 'witnesses':
                radioSelect = 'bmhwitnesses';
                break;
            case 'uinseann-mac-eoin-collection':
                radioSelect = 'uinseann';
                break;
            case '18th-military-mission':
                radioSelect = '18thmilitarymission';
                break;
            case 'air-defence-command':
                radioSelect = 'airdefencecommand';
                break;
            case 'the-army-inquiry-committee-papers':
                radioSelect = 'armyinquirycommitteepapers';
                break;
            case 'chief-of-staff-reports-to-the-executive-council':
                radioSelect =
                    'chiefofstaffreportstotheexecutivecouncil1923-1930';
                break;
            case 'civil-war-internment-collection':
                radioSelect = 'civilwarinternmentadmin';
                break;
            case 'civil-war-operations-and-intelligence-reports-collection':
                radioSelect = 'civilwaroperations';
                break;
            case 'civil-war-radio-reports':
                radioSelect = 'civilwarradioreports';
                break;
            case 'coastal-defence-artillery-collection':
                radioSelect = 'coastaldefenceartillery';
                break;
            case 'council-of-defence':
                radioSelect = 'councilofdefence';
                break;
            case 'court-martial-administration-civil-war-period':
                radioSelect = 'court-martialadministrationcivilwarperiod';
                break;
            // case 'department-of-defence-files':
            // radioSelect = 'departmentala-files';
            // break;
            case 'department-of-defence-a-series':
                radioSelect = 'departmentala-files';
                break;
            case 'historical-section-collection':
                radioSelect = 'historicalsectioncollection';
                break;
            case 'truce-liaison-and-evacuation-papers':
                radioSelect = 'liaisonandevacuationcollection';
                break;
            case 'military-intelligence-and-press-analysis':
                radioSelect = 'militaryintelligenceandpressanalysis';
                break;
            case 'military-intelligence-northern-ireland-1922-to-1925':
                radioSelect = 'militaryintelligencenorthernireland1922to1925';
                break;
            case 'post-master-general-daily-engineers-report':
                radioSelect = 'postmastergeneral';
                break;
            case 'railway-protection-and-repair-maintenance-corps':
                radioSelect = 'railwayprotectionandrepairmaintenancecorps';
                break;
            case 'united-nations-operations-in-congo':
                radioSelect = 'unitednationsoperationsincongo';
                break;
            case 'unit-journals-1939-to-1946':
                radioSelect = 'unitjournals1939to1946';
                break;
            case 'irish-sword':
                radioSelect = 'irish-sword';
                break;
            case 'nominal-rolls':
                radioSelect = 'nominalrolls';
                break;
            // case 'military-service-pensions-collection':
            //     radioSelect = 'mspc';
            //     break;
            // case 'search-the-mspc':
            //     radioSelect = 'mspc';
            //     break;
            // case 'brigade-activity-reports':
            //     radioSelect = 'mspc';
            //     break;
            // case 'easter-rising-1916':
            //     radioSelect = 'mspc';
            //     break;
            // case 'war-of-independence':
            //     radioSelect = 'mspc';
            //     break;
            // case 'truce':
            //     radioSelect = 'mspc';
            //     break;
            // case 'civil-war':
            //     radioSelect = 'mspc';
            //     break;
            default:
                radioSelect = null;
                break;
        }

        //select a radio button for site search/online collections/reading room
        if (radioId && radioSelect && selectedCollection && actionUrl) {
            // Check the checkbox
            var checkbox = document.getElementById(radioSelect);
            console.log('CheckBOX :' + radioSelect);

            if (checkbox) {
                checkbox.checked = true;

                $(checkbox).trigger('click');
            }

            if (
                radioId == 'online-collections' ||
                radioId == 'bureau-of-military-history-1913-1921' ||
                radioId == 'military-service-pensions-collection'
            ) {
                var arrow = $('#dropdown-onlinecollection');
                arrow.css('opacity', '1');
                let idlabelSelect = $('label[for=' + radioSelect + ']')
                    .text()
                    .toUpperCase();

                var radioLabel = $('#onlineCollectionsRadioLabel');
                radioLabel.addClass('show radiolabel');
                console.log(
                    'radio Button before text update and after show: ' +
                        radioLabel.html()
                );
                // Update the text content of the label while preserving the <span> tag
                radioLabel
                    .contents()
                    .filter(function () {
                        return this.nodeType === 3; // Text node
                    })
                    .first()
                    .replaceWith(idlabelSelect);
            }

            if (
                radioId == 'reading-room-collections' ||
                radioId == 'department-of-defence-file-series'
            ) {
                var arrow = $('#dropdown-readingroom');
                arrow.css('opacity', '1');
                console.log('radio Select 2 :' + radioSelect);
                let idlabelSelect = $('label[for=' + radioSelect + ']')
                    .text()
                    .toUpperCase();

                var radioLabel = $('#readingCollectionsRadioLabel');
                // radioLabel.addClass('show');
                // Update the text content of the label while preserving the <span> tag
                radioLabel
                    .contents()
                    .filter(function () {
                        return this.nodeType === 3; // Text node
                    })
                    .first()
                    .replaceWith(idlabelSelect);

                    $('#readingroom').removeClass('show').css('visibility', 'hidden');
            }

            if (
                radioId == 'resources'
            ) {
                var arrow = $('#dropdown-resources');
                arrow.css('opacity', '1');
                console.log('radio Select 2 :' + radioSelect);
                let idlabelSelect = $('label[for=' + radioSelect + ']')
                    .text()
                    .toUpperCase();

                var radioLabel = $('#resourcesCollectionsRadioLabel');
                radioLabel.addClass('show');
                // Update the text content of the label while preserving the <span> tag
                radioLabel
                    .contents()
                    .filter(function () {
                        return this.nodeType === 3; // Text node
                    })
                    .first()
                    .replaceWith(idlabelSelect);
            }

            //display showfields if for uinseann
            if (
                radioSelect == 'uinseann' ||
                radioSelect == 'mpdsearch' ||
                radioSelect == 'collins' ||
                radioSelect == 'irishvol' ||
                radioSelect == 'antoglac' ||
                radioSelect == 'census' ||
                radioSelect == 'gallery' ||
                radioSelect == 'bmhwitnesses' ||
                radioSelect == 'bmhcdindex' ||
                radioSelect == 'bmhgallery' ||
                radioSelect == 'oralhistories' ||
                radioSelect == 'nominalrolls' ||
                // radioSelect == 'mspc' ||
                radioSelect == 'irish-sword'
            ) {
                const $titleField = $('#search_title');
                const $subtitleField = $('#search_subtitle');
                const $keywordField = $('#search_scope_content');
                const $referenceField = $('#search_file_references');
                const $captionField = $('#search_caption');
                const $albumField = $('#search_album');
                const $firstnameField = $('#search_firstname');
                const $surnameField = $('#search_surname');
                const $kinFirstnameField = $('#search_nextofkinfirstname');
                const $kinSurnameField = $('#search_nextofkinsurname');
                const $ageField = $('#search_age');
                const $fromField = $('#search_from');
                const $toField = $('#search_to');

                const $yearField = $('#search_year');
                const $locationField = $('#search_location');
                const $intervieweeField = $('#search_interviewee');
                const $countyField = $('#search_county');
                const $searchsectionselectField = $('#search_section_select');
                const $searchtitleField = $('#search_title');
                const $searchKeywordField = $('#search_scope_content');

                const $authorField = $('#search_author');
                const $volumenField = $('#search_volume');
                const $issueField = $('#search_issue');
                const $articlenameField = $('#search_articlename');
                const $swordkeywordField = $('#search_keywordirishsword');
                const $swordtitleField = $('#search_titleirishsword');
                const $swordarticleField = $("div[name='articlename-multifieldsearch']");
                const $sworddateField = $("div[name='date-multifieldsearch']");

                const $sectionField = $('search_section_select');

                $('#showfields').css('display', 'block');
                if ($('#flush-collapseFields').hasClass('show'))
                    $('.accordion-button.showHideFields').click();

                // switch (radioSelect) {
                //     case 'uinseann':
                //         $('#showfields-title').text(
                //             'Search Uinseann Mac Eoin Collection using the fields below*:'
                //         );
                        
                //         break;
                //     case 'collins':
                //         $('#showfields-title').text(
                //             'Search Collins Papers (1917-1922) Collection using the fields below*:'
                //         );
                        
                //         break;
                //     case 'irishvol':
                //         $('#showfields-title').text(
                //             'Search The Irish Volunteer (1914-1916) Collection using the fields below*:'
                //         );
                        
                //         break;
                //     case 'antoglac':
                //         $('#showfields-title').text(
                //             'Search An tÓglach Magazine (1918-1933) Collection using the fields below*:'
                //         );
                        
                //         break;
                //     case 'census':
                //         $('#showfields-title').text(
                //             'Search Irish Army Census Collection (12/11/1922 - 13/11/1922) using the fields below*'
                //         );
                //         //gallery fields
                        
                //         break;
                //     case 'gallery':
                //         $('#showfields-title').text(
                //             'Search Irish Army Census Collection (12/11/1922 - 13/11/1922) using the fields below*'
                //         );
                        
                //         break;
                //     case 'irish-sword':
                //         $('#showfields-title').text(
                //             'Search Irish Sword Resources using the fields below*:'
                //         );

                //         break;
                //     case 'bmhwitnesses':
                //         $('#showfields-title').text(
                //             'Search Bureau of Military History Collection Witnesses using the fields below*:'
                //         );
                        
                //         break;
                //     case 'bmhcdindex':
                //         $('#showfields-title').text(
                //             'Search Bureau of Military History Collection CD index using the fields below*:'
                //         );
                        
                //         break;
                //     case 'mpdsearch':
                //         $('#showfields-title').text(
                //             'Search Maps, Plans and Drawings using the fields below*:'
                //         );
                        
                //         break;
                //     case 'oralhistories':
                //         $('#showfields-title').text(
                //             'Search Oral Histories Project using the fields below*:'
                //         );
                        
                //         break;
                    // case 'mspc':
                    //     $('#showfields-title').text(
                    //         'Military Service Pensions Collection using the fields below*:'
                    //     );
                    //     $albumField.closest('.form-group').hide();
                    //     $captionField.closest('.form-group').hide();
                    //     $subtitleField.closest('.form-group').hide();
                    //     $keywordField.closest('.form-group').show();
                    //     $titleField.closest('.form-group').show();
                    //     $toField.closest('.form-group').hide();
                    //     $fromField.closest('.form-group').hide();
                    //     //census fields
                    //     $firstnameField.closest('.form-group').hide();
                    //     $surnameField.closest('.form-group').hide();
                    //     $kinFirstnameField.closest('.form-group').hide();
                    //     $kinSurnameField.closest('.form-group').hide();
                    //     $ageField.closest('.form-group').hide();
                    //     //end census fields
                    //     $referenceField.closest('.form-group').hide();
                    //     //maps fields
                    //     $yearField.closest('.form-group').hide();
                    //     $locationField.closest('.form-group').hide();
                    //     // oral histories fields
                    //     $intervieweeField.closest('.form-group').hide();
                    //     $countyField.closest('.form-group').hide();
                    //     $searchsectionselectField.closest('.form-group').show();
                    //     // Irish Sword fields
                    //     $authorField.closest('.form-group').hide();
                    //     $volumenField.closest('.form-group').hide();
                    //     $issueField.closest('.form-group').hide();
                    //     $articlenameField.closest('.form-group').hide();
                    //     $swordkeywordField.closest('.form-group').hide();
                //     case 'nominalrolls':
                //         $('#showfields-title').text(
                //             'Search Nominal Rolls Project using the fields below*:'
                //         );
                        
                //         break;
                //     default:
                //         break;
                // }

                $('#onlinecollection').removeClass('show').css('visibility', 'hidden');

                // Check if we have a valid radioSelect and if the accordion isn't already open
            if (radioSelect && !$('#flush-collapseFields').hasClass('show')) {
                // Trigger click on the accordion button to slide it open
                    $('.accordion-button.showHideFields').trigger('click');
                    
                   
                }
            } else $('#showfields').css('display', 'none');
        }

        $('#gsearch').attr('action', actionUrl);
    });
}
